import Cookies from "js-cookie";

function isUnauthorized(error) {
    const status = error?.response?.status;
    return status === 401;
}

function clearAuthState() {
    try {
        Cookies.remove("access_token");
        Cookies.remove("mydev_token");
    } catch (e) {}
    try {
        localStorage.clear();
    } catch (e) {}
}

/**
 * Embed-forms pages currently use direct axios calls rather than the shared
 * Requests helpers. Call this in catch blocks to ensure a consistent redirect
 * when the session/token expires.
 *
 * @returns {boolean} whether the error was handled (redirect triggered).
 */
export function handleEmbedAuthRedirect(error) {
    if (!isUnauthorized(error)) {
        return false;
    }
    clearAuthState();
    // App's `/login` route redirects to SSO (MyDev).
    window.location.href = "/login";
    return true;
}

